function t(n) {
  return n == null || typeof n == "string" && n.trim() === "" ? null : Number(n);
}
function e(n) {
  return n.includes(".") && (/^(-)?\d+.*(\.|0)$/.test(n) || /^\.\d+$/.test(n));
}
function u(n) {
  return n == null ? !0 : !Number.isNaN(n);
}
function i(n, r) {
  return n == null ? "" : r === void 0 ? String(n) : n.toFixed(r);
}
function f(n) {
  if (n === null)
    return null;
  if (typeof n == "number")
    return n;
  {
    const r = Number(n);
    return Number.isNaN(r) ? null : r;
  }
}
export {
  i as format,
  e as isWipValue,
  t as parse,
  f as parseNumber,
  u as validator
};
